module.exports = __webpack_public_path__ + "img/icon.27abfab5.png";